/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { Modal, Form, Checkbox } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import FileSaver from 'file-saver';
import WithRouter from '../Extensions/WithRouter';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import Loader from '../Loader/Loader';
import {
  SPDX_EXTENSION_JSON,
  SPDX_EXTENSION_XML,
} from '../../constants/reports';
import './CycloneDXDocumentGenerator.css';

class CycloneDXDocumentGenerator extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.state = {
      isOpenMCD: props.isOpenMCD,
      isDownloadLoading: false,
      isLoading: false,
      isOpenWarnModal: false,
      creatorName: '',
      creatorEmail: '',
      creatorNumber: '',
      componentType: 'application',
      componentName: '',
      componentVersion: '',
      publisher: '',
      //componentDescription: '',
      modalValue: '',
      exportFormat: SPDX_EXTENSION_JSON,
      creatorNameError: false,
      componentNameError: false,
      emailError: false,
      useVex: false,
    };
    this.handleCreatorNameChange = this.handleCreatorNameChange.bind(this);
    this.handleCreatorEmailChange = this.handleCreatorEmailChange.bind(this);
    this.handleCreatorNumberChange = this.handleCreatorNumberChange.bind(this);
    this.handleExportFormat = this.handleExportFormat.bind(this);
    this.handleComponentType = this.handleComponentType.bind(this);
    this.handleComponentNameChange = this.handleComponentNameChange.bind(this);
    this.handleComponentVersionChange = this.handleComponentVersionChange.bind(this);
    this.handlePublisherChange = this.handlePublisherChange.bind(this);
    this.handleUseVexChange = this.handleUseVexChange.bind(this);
    //this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.createCycloneDXFileDownload = this.createCycloneDXFileDownload.bind(this);
    this.runWithModalValue = this.runWithModalValue.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeWarnModal = this.closeWarnModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isOpenMCD } = this.props;
    if (prevProps.isOpenMCD !== isOpenMCD) {
      this.setState({
        isOpenMCD,
        modalValue: '',
        isOpenWarnModal: false,
        creatorName: '',
        creatorEmail: '',
        creatorNumber: '',
        componentType: 'application',
        componentName: '',
        componentVersion: '',
        publisher: '',
        //componentDescription: '',
        creatorNameError: false,
        componentNameError: false,
        emailError: false,
        exportFormat: SPDX_EXTENSION_JSON,
        useVex: false,
      }, () => {
        if (isOpenMCD) {
          this.getPacakageInfoWithCycloneDx();
        }
      });
    }
  }

  handleCreatorNameChange(e) {
    this.setState({
      creatorName: e.target.value,
    });
  }

  handleCreatorEmailChange(e) {
    this.setState({
      creatorEmail: e.target.value,
      emailError: false,
    });
  }

  handleCreatorNumberChange(e) {
    this.setState({
      creatorNumber: e.target.value,
    });
  }

  handleExportFormat(e) {
    this.setState({
      exportFormat: e.target.value,
    });
  }

  handleComponentType(e) {
    this.setState({
      componentType: e.target.value,
    });
  }

  handleComponentNameChange(e) {
    this.setState({
      componentName: e.target.value,
      componentNameError: false,
    });
  }

  handleComponentVersionChange(e) {
    this.setState({
      componentVersion: e.target.value,
    });
  }

  handlePublisherChange(e) {
    this.setState({
      publisher: e.target.value,
    });
  }

  handleUseVexChange = (e, { checked }) => {
    this.setState({
      useVex: checked,
    });
  };

  /*
  handleDescriptionChange(e) {
    this.setState({
      componentDescription: e.target.value,
    });
  }
*/
  onSubmit() {
    const { translate } = this.props;

    if (!this.validateForm()) {
      return;
    }

    this.modalHeader = translate('modal.title.notice');
    this.modalBody = translate('modal.message.create_document');
    this.setState({
      isOpenWarnModal: true,
      modalValue: 'create',
    });
  }

  validateForm = () => {
    const {
      componentName,
      creatorEmail,
    } = this.state;

    const validation = {
      componentType: true,
      componentName: true,
      creatorEmail: true,
    };

    if (componentName.trim().length === 0) {
      this.setState({
        componentNameError: true,
      });
      validation.componentName = false;
      this.componentName.focus();
      this.componentName.scrollIntoView();
      return false;
    }

    if (creatorEmail.trim().length !== 0) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isValidFormat = emailRegex.test(creatorEmail);

      if (!isValidFormat) {
        this.setState({
          emailError: true,
        });
        validation.creatorEmail = false;
        this.email.focus();
        this.email.scrollIntoView();
        return false;
      }
    }

    return validation.componentType && validation.componentName;
  };

  getPacakageInfoWithCycloneDx = () => {
    const { reportId } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getPacakageInfoWithCycloneDx(reportId)
        .then((response) => {
          const data = convertPropertiesToCamelCase(response.response);
          this.setState({
            isLoading: false,
            componentName: data.componentName,
            componentType: data.componentType,
            componentVersion: data.componentVersion,
            //componentDescription: data.description,
            creatorName: data.creatorName,
            creatorEmail: data.creatorEmail,
            creatorNumber: data.phoneNumber,
            publisher: data.publisher,
            useVex: data.useVex,
          });

        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  };

  createCycloneDXFileDownload = () => {
    const { reportId, closeModal, state } = this.props;
    const {
      exportFormat,
      componentType,
      componentName,
      componentVersion,
      //componentDescription,
      creatorName,
      creatorEmail,
      creatorNumber,
      publisher,
      isDownloadLoading,
      useVex,
    } = this.state;

    const obj = {
      export_format: exportFormat,
      component_type: componentType,
      component_name: componentName,
      creator_name: creatorName,
      creator_email: creatorEmail,
      phone_number: creatorNumber,
      component_version: componentVersion,
      publisher,
      description: '',
      use_vex: useVex,
    };

    if (state.user.currentPrecisionLevel) {
      obj.precision_level = state.user.currentPrecisionLevel;
    }

    const fileName = `sbom.cyclonedx.clarity-${componentName}.${exportFormat}`;

    if (isDownloadLoading) {
      api
        .createCycloneDXFileDownload(reportId, obj)
        .then((res) => {
          const blob = new Blob([res], { type: 'application/octet-stream' });
          FileSaver.saveAs(blob, fileName);

          this.setState({
            isDownloadLoading: false,
          });
          closeModal();
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isDownloadLoading: false,
          });
        });
    }
  };

  runWithModalValue() {
    const { closeModal } = this.props;
    const { modalValue } = this.state;

    if (modalValue.indexOf('create') > -1) {
      this.setState({
        isOpenWarnModal: false,
        isDownloadLoading: true,
      }, () => {
        this.createCycloneDXFileDownload();
      });
    } else {
      closeModal();
    }
  }

  closeModal(e) {
    const { translate } = this.props;
    if (e.target.classList[0] === 'right_button') {
      return null;
    }

    this.modalHeader = translate('modal.title.attention');
    this.modalBody = translate('modal.message.create_document_cancel');
    this.setState({
      isOpenWarnModal: true,
      modalValue: 'MCX',
    });
  }

  closeWarnModal() {
    this.setState({
      isOpenWarnModal: false,
    });
  }

  render() {
    const { translate } = this.props;
    const {
      isOpenWarnModal,
      creatorName,
      creatorEmail,
      creatorNumber,
      componentType,
      componentName,
      componentVersion,
      publisher,
      //componentDescription,
      isOpenMCD,
      isLoading,
      isDownloadLoading,
      exportFormat,
      creatorNameError,
      componentNameError,
      emailError,
      useVex,
    } = this.state;

    const getModalContent = () => {
      if (isDownloadLoading) {
        return (
          <div className="setting_popup_wrap">
            <div className="setting_popup dx">
              <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                <Loader
                  style={{
                    position: 'relative',
                    width: '80%',
                    height: '80%',
                    marginBottom: '15%',
                  }}
                />
                <span
                  style={{
                    fontWeight: '500',
                    fontSize: '16px',
                    marginTop: '30%',
                    display: 'inline-block',
                  }}
                >
                  {translate('modal.message.prepare_cyclonedx_download')}
                </span>
              </div>
            </div>
          </div>
        );
      }

      if (isLoading) {
        return (
          <div className="setting_popup_wrap">
            <div className="setting_popup dx">
              <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                <Loader
                  style={{
                    position: 'relative',
                    width: '80%',
                    height: '80%',
                    marginBottom: '15%',
                  }}
                />
                <span
                  style={{
                    fontWeight: '500',
                    fontSize: '16px',
                    marginTop: '30%',
                    display: 'inline-block',
                  }}
                >
                  {translate('modal.message.loading')}
                </span>
              </div>
            </div>
          </div>
        );
      }

      return (
        <div>
          <div className="setting_popup_wrap">
            <div
              className="setting_popup dx"
            >
              <div className="setting_popup_header">
                <h2 className="popup_name">{translate('modal.title.create_cyclonedx_document')}</h2>
                <a
                  className="popup_close_button"
                  onKeyUp={this.closeModal}
                  onClick={this.closeModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <Scrollbars
                style={{
                  height: '395px',
                  overflow: 'hidden',
                  position: 'relative',
                }}
                renderTrackHorizontal={() => {
                  return <div />;
                }}
                renderThumbHorizontal={() => {
                  return <div />;
                }}
              >
                <Form>
                  <div className="setting_popup_content_wrap">
                    <h3 className="content_title">Export Setting</h3>
                  </div>
                  <div className="two unstackable fields">
                    <div className="field">
                      <label htmlFor="exportFormat">
                        {translate('modal.title.export_format')}
                      </label>
                      <select
                        id="exportFormat"
                        value={exportFormat}
                        onChange={this.handleExportFormat}
                      >
                        <option value={SPDX_EXTENSION_JSON}>JSON</option>
                        <option value={SPDX_EXTENSION_XML}>XML</option>
                      </select>
                    </div>
                    <div
                      className="field"
                      title="Vulnerability Exploitability eXchange"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%',
                        marginTop: 'auto',
                        marginBottom: 'auto',
                      }}
                    >
                      <Checkbox
                        id="useVex"
                        label="Include VEX"
                        checked={useVex}
                        onChange={this.handleUseVexChange}
                      />
                    </div>
                  </div>
                  <div className="line" />

                  <div className="setting_popup_content_wrap">
                    <h3
                      className="content_title"
                    >
                      {translate('modal.title.creator_information')}
                    </h3>
                  </div>
                  <Form.Group unstackable widths={2}>
                    <Form.Field error={creatorNameError}>
                      <label>
                        {translate('modal.title.creator_name')}
                      </label>
                      <input
                        type="text"
                        value={creatorName}
                        onChange={this.handleCreatorNameChange}
                        placeholder="The name of a contact"
                      />
                    </Form.Field>
                    <Form.Field
                      error={emailError}
                    >
                      <label
                        ref={(ref) => {
                          this.email = ref;
                        }}
                      >
                        {translate('modal.title.creator_email')}
                      </label>
                      <input
                        type="text"
                        value={creatorEmail}
                        onChange={this.handleCreatorEmailChange}
                        placeholder="The email address of the contact"
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.title.create_phone_number')}</label>
                      <input
                        type="text"
                        value={creatorNumber}
                        onChange={this.handleCreatorNumberChange}
                        placeholder="The phone number of the contact"
                      />
                    </Form.Field>
                  </Form.Group>
                  <div className="line" />
                  <div className="setting_popup_content_wrap">
                    <h3 className="content_title">
                      {translate('modal.title.component_information')}
                    </h3>
                  </div>
                  <Form.Group unstackable widths={2}>
                    <Form.Field>
                      <label>
                        {translate('modal.title.component_type')}
                        <em style={{ marginLeft: '0' }} className="asterisk" />
                      </label>
                      <select value={componentType} onChange={this.handleComponentType}>
                        <option value="application">Application</option>
                        <option value="framework">Framework</option>
                        <option value="library">Library</option>
                        <option value="container">Container</option>
                        <option value="operating-system">OperatingSystem</option>
                        <option value="device">Device</option>
                        <option value="firmware">Firmware</option>
                        <option value="file">File</option>
                      </select>
                    </Form.Field>
                    <Form.Field error={componentNameError}>
                      <label
                        ref={(ref) => {
                          this.componentName = ref;
                        }}
                      >
                        {translate('modal.title.component_name_cyclonedx')}
                        <em style={{ marginLeft: '0' }} className="asterisk" />
                      </label>
                      <input
                        type="text"
                        placeholder={translate('modal.title.component_name_cyclonedx')}
                        value={componentName}
                        onChange={this.handleComponentNameChange}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.title.component_version_cyclonedx')}</label>
                      <input
                        type="text"
                        placeholder="The component version of scanned"
                        value={componentVersion}
                        onChange={this.handleComponentVersionChange}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group widths={2}>
                    <Form.Field>
                      <label>
                        {translate('modal.title.publisher')}
                      </label>
                      <input
                        type="text"
                        value={publisher}
                        placeholder="The person(s) or organization(s)"
                        onChange={this.handlePublisherChange}
                      />
                    </Form.Field>
                  </Form.Group>
                  {/**
                   *
                    <Form.TextArea
                      label={translate('modal.title.description_cyclonedx')}
                      placeholder="Specifies a description"
                      value={componentDescription}
                      onChange={this.handleDescriptionChange}
                    />
                   *
                  */}
                </Form>
              </Scrollbars>
              <div className="setting_popup_button_wrap">
                <a
                  className="button cencel_button"
                  onKeyUp={this.closeModal}
                  onClick={this.closeModal}
                  style={{ cursor: 'pointer' }}
                >
                  {translate('modal.button.cancel')}
                </a>
                <a
                  className="button save_button"
                  onKeyUp={this.closeModal}
                  onClick={this.onSubmit}
                  style={{ cursor: 'pointer' }}
                >
                  {translate('modal.button.ok')}
                </a>
              </div>
            </div>
          </div>
          <Modal open={isOpenWarnModal} onClose={this.closeWarnModal}>
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.modalHeader}</h2>
                  <p className="text">{this.modalBody}</p>
                  <div className="button_wrap">
                    <a
                      className="left_button"
                      onKeyUp={this.closeWarnModal}
                      onClick={this.closeWarnModal}
                    >
                      {translate('modal.button.cancel')}
                    </a>
                    <a
                      className="right_button"
                      onKeyUp={this.runWithModalValue}
                      onClick={this.runWithModalValue}
                    >
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      );
    };
    return (
      <Modal open={isOpenMCD} onClose={this.closeModal} className="create_dx">
        {getModalContent()}
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(CycloneDXDocumentGenerator)));
